import axios from 'axios';
import { Designer, Project, Job, Review } from '../types';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:6000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Designer endpoints
export const designerApi = {
  getAll: () => api.get<Designer[]>('/designers'),
  getById: (id: number) => api.get<Designer>(`/designers/${id}`),
  getPortfolio: (id: number) => api.get<string[]>(`/designers/${id}/portfolio`),
  getReviews: (id: number) => api.get<Review[]>(`/designers/${id}/reviews`),
};

// Project endpoints
export const projectApi = {
  getAll: () => api.get<Project[]>('/projects'),
  getById: (id: number) => api.get<Project>(`/projects/${id}`),
  create: (project: Omit<Project, 'id'>) => api.post<Project>('/projects', project),
  update: (id: number, project: Partial<Project>) => api.put<Project>(`/projects/${id}`, project),
};

// Job endpoints
export const jobApi = {
  getAll: () => api.get<Job[]>('/jobs'),
  getById: (id: number) => api.get<Job>(`/jobs/${id}`),
  create: (job: Omit<Job, 'id'>) => api.post<Job>('/jobs', job),
};

// Auth endpoints
export const authApi = {
  login: (email: string, password: string) => api.post('/auth/login', { email, password }),
  register: (userData: { name: string; email: string; password: string; role: 'designer' | 'client' }) =>
    api.post('/auth/register', userData),
  forgotPassword: (email: string) => api.post('/auth/forgot-password', { email }),
  resetPassword: (token: string, password: string) => api.post('/auth/reset-password', { token, password }),
};

export default api; 